/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Navbar - toggle backdrop on dropdown open
document.querySelectorAll('#navbar .dropdown-toggle').forEach(($dropdown) => {
    $dropdown.addEventListener('show.bs.dropdown', (e) => {
        if (!document.querySelector('.modal-backdrop')) {
            document.body.insertAdjacentHTML(
                'beforeend', '<div id="navbar-modal-backdrop" class="modal-backdrop fade"></div>'
            )

            setTimeout(() => {
                document.querySelector('#navbar-modal-backdrop').classList.add('show')
            }, 150)

            document.documentElement.classList.add('navbar-dropdown-is-open')
        }
    })
    $dropdown.addEventListener('hidden.bs.dropdown', (e) => {
        if (!document.querySelector('#navbar .dropdown-menu.show')) {
            document.querySelector('#navbar-modal-backdrop')?.remove()
            document.documentElement.classList.remove('navbar-dropdown-is-open')
        }
    })
})

// Countdown timer
const initCountdownTimers = () => {
    document.querySelectorAll('.announcement-countdown-timer').forEach((el) => {
        const end = Number(el.dataset.time) * 1000

        const seconds = 1000
        const minutes = seconds * 60
        const hours = minutes * 60

        const x = setInterval(() => {
            const now = new Date().getTime()
            const difference = end - now

            if (difference < 0) {
                clearInterval(x)
                return
            }

            el.querySelector('[data-hours').innerText = `${Math.floor((difference) / hours)}h`
            el.querySelector('[data-minutes').innerText = `${Math.floor((difference % hours) / minutes)}m`
            el.querySelector('[data-seconds').innerText = `${Math.floor((difference % minutes) / seconds)}s`
        }, seconds)
    })
}
initCountdownTimers()

// Header - Adjust sticky position on scroll
window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
        document.querySelector('#header-row-desktop').classList.remove('py-6')
        document.querySelector('#header-row-desktop').classList.add('py-4')
        document.querySelector('#header-row-mobile').classList.remove('py-4')
        document.querySelector('#header-row-mobile').classList.add('py-3')
    } else {
        document.querySelector('#header-row-desktop').classList.add('py-6')
        document.querySelector('#header-row-desktop').classList.remove('py-4')
        document.querySelector('#header-row-mobile').classList.add('py-4')
        document.querySelector('#header-row-mobile').classList.remove('py-3')
    }
})

// Header - Listen for megamenu dropdown events
document.querySelectorAll('#navbar-desktop .position-static .dropdown-toggle').forEach((dropdown) => {
    dropdown.addEventListener('show.bs.dropdown', (e) => {
        document.querySelector('#header-inner').style.borderRadius = '0'
    })
    dropdown.addEventListener('hide.bs.dropdown', (e) => {
        document.querySelector('#header-inner').style.borderRadius = '0 0 1.5rem 1.5rem'
    })
})

// Carousel - Go to corresponding slide on editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

// Newsletter - Scroll to it after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter-form').scrollIntoView()
    }, 750)
}

// Featured Products - Init Splide Slider
const initFeaturedProductsSliders = () => {
    document.querySelectorAll('.splide-products:not(.init)')
        .forEach((el) => {
            const splide = new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                mediaQuery: 'min',
                perPage: Number(el.dataset.breakpointXs),
                drag: el.dataset.freeScroll === 'true' ? 'free' : true,
                padding: '10%',
                breakpoints: {
                    576: { perPage: Number(el.dataset.breakpointSm), padding: 0 },
                    768: { perPage: Number(el.dataset.breakpointMd), padding: 0 },
                    992: { perPage: Number(el.dataset.breakpointLg), padding: 0 },
                    1200: { perPage: Number(el.dataset.breakpointXl), padding: 0 },
                    1400: { perPage: Number(el.dataset.breakpointXxl), padding: 0 }
                }
            })

            const fixArrowsPosition = () => {
                el.querySelectorAll('.splide__arrow').forEach((arrow) => {
                    arrow.style.top = el.querySelector('.product-img').clientHeight / 2 + 'px'
                    arrow.style.transform = 'translateY(-25%)'
                })
            }

            splide.on('updated', () => {
                fixArrowsPosition()
            })

            splide.mount()
            el.classList.add('init')

            setTimeout(() => {
                fixArrowsPosition()
            }, 500)
        })
}
initFeaturedProductsSliders()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-products')) {
        initFeaturedProductsSliders()
    }
})

/*
    Testimonial section
*/
// Init Splide Carousel
const initTestimonialsSlider = () => {
    document.querySelectorAll('.testimonials .splide:not(.init)')
        .forEach((el) => {
            const splide = new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                mediaQuery: 'min',
                perPage: Number(el.dataset.breakpointXs),
                drag: el.dataset.freeScroll === 'true' ? 'free' : true,
                // focus: 'center',
                padding: { right: '3rem' },
                breakpoints: {
                    576: { perPage: Number(el.dataset.breakpointSm), padding: 0 },
                    768: { perPage: Number(el.dataset.breakpointMd), padding: 0 },
                    992: { perPage: Number(el.dataset.breakpointLg), padding: 0 },
                    1200: { perPage: Number(el.dataset.breakpointXl), padding: 0 },
                    1400: { perPage: Number(el.dataset.breakpointXxl), padding: 0 }
                }
            })

            splide.mount()
            el.classList.add('init')
        })
}
initTestimonialsSlider()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.testimonials')) {
        initTestimonialsSlider()
    }
})

/*
    Product Sticky ATC  - Handle Visibility
*/
// const productStickyATCVisibility = () => {
//     const $stickyATC = document.querySelector('.product-sticky-atc')

//     if ($stickyATC) {
//         const $header = document.querySelector('#shopify-section-header.sticky-top')
//         const $stickyATC = document.querySelector('.product-sticky-atc')
//         const $atcForm = document.querySelector('.product form[action="/cart/add"]')
//         const threshold = $atcForm.getBoundingClientRect().bottom

//         window.addEventListener('scroll', () => {
//             if (window.scrollY > threshold) {
//                 $stickyATC.classList.add('show')
//                 $header.classList.add('hide')
//             } else {
//                 $stickyATC.classList.remove('show')
//                 $header.classList.remove('hide')
//             }
//         })
//     }
// }
// productStickyATCVisibility()

/*
    Product Sticky ATC  - Handle variant change
*/
// const productStickyATCVariantChange = () => {
//     const $variantSelecetor = document.querySelector('.product-sticky-atc select[name="id"]')

//     $variantSelecetor?.addEventListener('change', (e) => {
//         const variantImage = $variantSelecetor.options[$variantSelecetor.selectedIndex].dataset.variantImg

//         if (variantImage) {
//             const $img = $variantSelecetor.closest('.product-sticky-atc').querySelector('.product-img')
//             $img.setAttribute('src', variantImage)
//         }
//     })
// }
// productStickyATCVariantChange()

/*
    Recommended Products
*/
const initRecommendedProducts = () => {
    const recommendedProducts = document.querySelector('.recommended-products')
    if (recommendedProducts) {
        const {
            sectionId, baseUrl, productId, limit
        } = recommendedProducts.dataset
        const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`
        fetch(url)
            .then((response) => response.text())
            .then((data) => {
                recommendedProducts.closest('.shopify-section').outerHTML = data
                initFeaturedProductsSliders()
                // initWishlist()
            })
    }
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
})

// Parallax video
const initParallaxVideo = () => {
    document.querySelectorAll('.parallax-video .jarallax').forEach((jarallaxElem) => {
        jarallax(jarallaxElem, {
            type: jarallaxElem.dataset.parallaxType,
            speed: Number(jarallaxElem.dataset.parallaxSpeed),
            disableParallax: jarallaxElem.dataset.parallaxDisableMobile === 'true' ? /iPad|iPhone|Android/ : false,
            videoSrc: jarallaxElem.dataset.videoSrc,
            videoLazyLoading: true
        })
    })
}
initParallaxVideo()

document.querySelectorAll('.parallax-video-modal').forEach((modal) => {
    const modalIframe = modal.querySelector('iframe')
    const modalMp4Video = modal.querySelector('video')
    const videoId = modal.dataset.videoId

    modal.addEventListener('show.bs.modal', () => {
        const parallaxIframe = modal.closest('.shopify-section').querySelector('.jarallax iframe')
        const parallaxMp4Video = modal.closest('.shopify-section').querySelector('.jarallax video')

        if (parallaxIframe) {
            parallaxIframe.style.opacity = '0'
        }

        if (parallaxMp4Video) {
            parallaxMp4Video.style.opacity = '0'
        }

        switch (modal.dataset.videoType) {
        case 'youtube':
            if (modalIframe) {
                modalIframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?&autoplay=1`)
            }
            break
        case 'vimeo':
            if (modalIframe) {
                modalIframe.setAttribute('src', `https://player.vimeo.com/video/${videoId}?autoplay=true`)
            }
            break
        case 'mp4':
            if (modalMp4Video) {
                modalMp4Video.play()
            }
        }
    })

    modal.addEventListener('hide.bs.modal', () => {
        const parallaxIframe = modal.closest('.shopify-section').querySelector('.jarallax iframe')
        const parallaxMp4Video = modal.closest('.shopify-section').querySelector('.jarallax video')

        if (parallaxIframe) {
            parallaxIframe.style.opacity = '1'
        }

        if (parallaxMp4Video) {
            parallaxMp4Video.style.opacity = '1'
        }

        if (modalIframe) {
            modalIframe.setAttribute('src', '')
        }

        if (modalMp4Video) {
            modalMp4Video.pause()
        }
    })
})

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.parallax-video')) {
        initParallaxVideo()
    }
})

// Bundle and save
document.querySelectorAll('.bundle-and-save .btn-atc').forEach((btn) => {
    btn.addEventListener('click', () => {
        setTimeout(() => {
            document.querySelectorAll('.bundle-and-save a[href*="checkout"]').forEach(link => {
                link.textContent = 'Proceed to checkout →'
                link.classList.remove('btn-outline-secondary')
                link.classList.add('btn-secondary')
            })
        }, 1500)
    })
})
